import { render, staticRenderFns } from "./commissionRelatedConfig.vue?vue&type=template&id=5c95fac6&scoped=true"
import script from "./commissionRelatedConfig.vue?vue&type=script&lang=js"
export * from "./commissionRelatedConfig.vue?vue&type=script&lang=js"
import style0 from "./commissionRelatedConfig.vue?vue&type=style&index=0&id=5c95fac6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c95fac6",
  null
  
)

export default component.exports